import steps from '@elotech/arc/src/assets/components/onboarding/oxy.js';
import axios from 'axios';
import AuthService from 'common/auth/AuthService';
import keycloakService from 'keycloak/KeycloakService';
import React, { useContext, useEffect, useState } from 'react';
import { ShepherdTour, ShepherdTourContext } from 'react-shepherd';

const OnboardingConsumer = ({ children }) => {
  const tour = useContext(ShepherdTourContext);
  const [userProfile, setUserProfile] = useState({
    attributes: {
      primeiro_acesso: ['FALSE']
    }
  });

  useEffect(() => {
    const { success } = keycloakService.getUserProfile();

    success(user => {
      setUserProfile(prevState => {
        return {
          ...prevState,
          ...user
        };
      });
    });
  }, []);

  useEffect(() => {
    if (userProfile?.attributes?.primeiro_acesso?.[0] === 'TRUE') {
      updateUserAttributes();
      tour.start();
    }

    // eslint-disable-next-line
  }, [userProfile]);

  const updateUserAttributes = () => {
    const attributes = {
      ...userProfile.attributes,
      primeiro_acesso: ['FALSE']
    };

    return axios.put(
      `${keycloakService.getUrl()}/usuario/me/attributes`,
      attributes,
      {
        headers: {
          Authorization: `Bearer ${keycloakService.getToken()}`,
          'x-tenant-host': window.location.host
        }
      }
    );
  };

  return <>{children}</>;
};

const Onboarding = ({ children, isCloud }) => {
  const protocoloSteps = steps.map(step => {
    if (step.id === 'step4') {
      return {
        ...step,
        attachTo: {
          ...step.attachTo,
          element: '.page-name'
        },
        text: ['Nesta área fica a indicação de página você está.']
      };
    }

    return step;
  });

  const tourOptions = {
    defaultStepOptions: {
      cancelIcon: {
        enabled: true
      }
    },
    exitOnEsc: true,
    useModalOverlay: true
  };

  const isLogged = AuthService.isLogged() || keycloakService.isLogged();

  if (!isLogged || !isCloud) {
    return children;
  }

  return (
    <ShepherdTour steps={protocoloSteps} tourOptions={tourOptions}>
      <OnboardingConsumer>{children}</OnboardingConsumer>
    </ShepherdTour>
  );
};

export default Onboarding;
